<template>
  <div class="ssn-filter-management">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-data-table
          :headers="layouts.settings.headers"
          :items="dataSources.ssnFilterArray"
          :loading="layouts.loading.ssnFilter"
          class="elevation-1"
          :search="layouts.data.search"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>SSN Filter Management</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="layouts.data.search"
                append-icon="mdi-magnify"
                style="max-width: 400px; padding-right: 10px;"
                label="Search by SSN #"
                hide-details
              ></v-text-field>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="onClickSSNFilterAction(assets.dataType.ActionConst.ADD)"
              >
                Add
              </v-btn>
              <v-btn
                color="primary"
                dark
                class="mb-2 m-l-5"
                @click="onClickSSNFilterAction(assets.dataType.ActionConst.IMPORT)"
              >
                Batch Import
              </v-btn>
              <input type="file" ref="refFile" style="display: none" v-on:change="fileUpload" accept="text/plain">
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="onClickSSNFilterAction(assets.dataType.ActionConst.DELETE, item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-dialog v-model="layouts.dialogs.ssnFilter.display" persistent max-width="550px">
          <v-card>
            <v-card-title>
              <span>SSN Filter Management</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="layouts.dialogs.ssnFilter.display = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <ValidationObserver ref="observer" v-slot="{ validate, reset }">
                <ValidationProvider name="SSN" rules="required|ssn" v-slot="{ errors }">
                  <v-text-field
                    v-model="layouts.dialogs.ssnFilter.dataSources.ssn"
                    label="SSN"
                    hide-details="auto"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                :loading="layouts.dialogs.ssnFilter.loading"
                @click="onClickSave"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { DataType, Popup, Tool } from '@/util'
import { LFSConfigurationApi } from '@/api/pandaria'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
const popup = new Popup()
const tool = new Tool()
export default {
  name: 'ssn-filter-management',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    assets: {
      dataType: DataType
    },
    dataSources: {
      ssnFilterArray: []
    },
    layouts: {
      data: {
        search: '',
        companyId: 1,
        portfolioId: -1,
        channelId: -1
      },
      settings: {
        headers: [
          { text: 'SSN #', value: 'parameterValue', sortable: false },
          { text: 'Action', value: 'action', sortable: false }
        ]
      },
      loading: {
        ssnFilter: false
      },
      dialogs: {
        ssnFilter: {
          display: false,
          action: DataType.ActionConst.ADD,
          loading: false,
          dataSources: {
            ssn: ''
          }
        }
      }
    }
  }),
  mounted () {
    this.initSSNFilterManagement()
  },
  methods: {
    initSSNFilterManagement () {
      const $this = this
      $this.layouts.loading.ssnFilter = true
      LFSConfigurationApi.listComplianceLeadFilterParameter(null, function (result) {
        $this.dataSources.ssnFilterArray = tool.isEmpty(result) ? [] : result
        $this.layouts.loading.ssnFilter = false
      }, function () {
        $this.dataSources.ssnFilterArray = []
        $this.layouts.loading.ssnFilter = false
      })
    },
    onClickSSNFilterAction (action, item) {
      const $this = this
      switch (action) {
        case DataType.ActionConst.ADD:
          this.layouts.dialogs.ssnFilter.display = true
          this.layouts.dialogs.ssnFilter.action = DataType.ActionConst.ADD
          this.layouts.dialogs.ssnFilter.dataSources.ssn = ''
          break
        case DataType.ActionConst.DELETE:
          popup.popupForQuestion('Are you sure to delete the value?', null, function () {
            LFSConfigurationApi.deleteComplianceLeadFilterParameter(item.id, function () {
              popup.popupForSuccess('Success to delete the value', function () {
                $this.initSSNFilterManagement()
              })
            }, function (result) {
              popup.popupForError(result.message)
            })
          })
          break
        case DataType.ActionConst.IMPORT:
          this.$refs.refFile.dispatchEvent(new MouseEvent('click'))
          break
        default:
          break
      }
    },
    fileUpload () {
      const $this = this
      const selectedFile = $this.$refs.refFile.files[0]
      const index = selectedFile.name.lastIndexOf('.')
      const fileType = selectedFile.name.substring(index)
      const size = selectedFile.size
      if (fileType !== '.txt') {
        popup.popupForWarning('You cannot import files of this type')
        return
      }
      if (size > 1048576) {
        popup.popupForWarning('Upload file size cannot exceed 1MB')
        return
      }

      const leadFilterParameter = {
        companyId: $this.layouts.data.companyId,
        channelId: $this.layouts.data.channelId,
        portfolioId: $this.layouts.data.portfolioId,
        type: DataType.LeadFilterTypeEnum.COMPLAINT_FILTER.value,
        sectionKey: 'PERSONAL',
        parameterKey: 'SSN',
        operator: 'IN'
      }
      const request = new FormData()
      request.append('file', selectedFile)
      request.append('leadFilterParameter', JSON.stringify(leadFilterParameter))
      LFSConfigurationApi.importComplianceLeadFilterParameter(request, function () {
        popup.popupForSuccess('Success to import data', function () {
          $this.initSSNFilterManagement()
        })
      }, function (result) {
        popup.popupForError(result.message)
      })
    },
    onClickSave () {
      const $this = this
      $this.$refs.observer.validate().then(observerResult => {
        if (observerResult) {
          $this.layouts.dialogs.ssnFilter.loading = true
          const request = {
            companyId: $this.layouts.data.companyId,
            portfolioId: $this.layouts.data.portfolioId,
            channelId: $this.layouts.data.channelId,
            type: DataType.LeadFilterTypeEnum.COMPLAINT_FILTER.value,
            sectionKey: 'PERSONAL',
            parameterKey: 'SSN',
            operator: 'IN',
            parameterValue: $this.layouts.dialogs.ssnFilter.dataSources.ssn
          }
          LFSConfigurationApi.addComplianceLeadFilterParameter(request, function () {
            $this.layouts.dialogs.ssnFilter.loading = false
            $this.layouts.dialogs.ssnFilter.display = false
            $this.initSSNFilterManagement()
          }, function (result) {
            $this.layouts.dialogs.ssnFilter.loading = false
            popup.popupForError(result.message)
          })
        }
      })
    }
  }
}
</script>
